export default "__VITE_ASSET__Cx7Gpra2__"